import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { Input } from './components/Input';
import { Popup } from './components/Popup';
import { IOption, TOptionValue } from './types';

export interface ISelectMobileProps {
  options: IOption[];
  value: TOptionValue;
  title?: string;
  text?: string;
  onChange?(value: TOptionValue): void;
}

export const SelectMobile: React.FC<ISelectMobileProps> = ({ options, value, title, text, onChange }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = useEventCallback(() => {
    setOpen(true);
  });

  const handleClose = useEventCallback(() => {
    setOpen(false);
  });

  return (
    <div>
      <Input open={open} text={text} onClick={handleOpen} />
      {open && <Popup options={options} value={value} title={title} onChange={onChange} onClose={handleClose} />}
    </div>
  );
};
